import React from 'react'
import { fichasData } from '../../../data/fichas.data';


import closeBtn from './../../../UI/general/close.svg'

interface Props{
    isFichaOpened: boolean,
    selectedBike: any,
    handleOpenFichaTecnica: any,
    handleOpenOnline: any
}

interface State{
    currentFichaSelected: any
}

class FichaMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentFichaSelected: []
        }
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.selectedBike !== this.props.selectedBike && this.props.selectedBike.Nombre !== ""){
            this.setState({
                currentFichaSelected: fichasData()[0][this.props.selectedBike.Nombre]
            })
        }
    }

    handleGenerateThumb = () => {
        if(this.state.currentFichaSelected && this.state.currentFichaSelected.Thumb && this.props.selectedBike.Nombre){
            return(<img src={this.state.currentFichaSelected.Thumb.default} />)
        }
    }

    render(): React.ReactNode {
        return (
            <div className={this.props.isFichaOpened ? "ficha-bar-mobile fade-in":"ficha-bar-mobile fade-out"}>
                <div className='gallery-bar-header-mobile'>
                    <div className='gallery-bar-title-mobile'>
                        FICHA TÉCNICA
                    </div>
                    <img className='close-btn-gallery-mobile' src={closeBtn} onClick={() => {this.props.handleOpenFichaTecnica(false)}}/>
                </div>
                <div className='gallery-hr-mobile'/>
                <div className='ficha-tecnica-text-mobile'>
                    Contamos con un documento personalizado con toda la información que necesitas. Puedes descargarlo.
                </div>
                <div className='ficha-download-btn-mobile'>
                    <a href={this.state.currentFichaSelected && this.state.currentFichaSelected.Ficha ? this.state.currentFichaSelected.Ficha.default:""} download>
                        DESCARGAR
                    </a>
                </div>
            </div>
        )
    }
}

export default FichaMobile